import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Flower2 } from "lucide-react";
import { NAV_LINKS } from "../data/site";

export const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#FBF9F5]/85 backdrop-blur-xl border-b border-[#1C1E1D]/10" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2.5" data-testid="nav-logo">
          <span className="w-9 h-9 rounded-full bg-[#1C211E] text-[#F5F3ED] flex items-center justify-center">
            <Flower2 size={17} strokeWidth={1.5} />
          </span>
          <span className="font-serif text-lg leading-tight">Veronica Sciacquatori</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => go(e, l.href)} data-testid={`nav-link-${l.href.slice(1)}`}
               className="text-sm text-[#525754] hover:text-[#1C1E1D] transition-colors duration-300">{l.label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={(e) => go(e, "#contatti")} data-testid="nav-cta-booking"
                  className="hidden sm:inline-flex items-center rounded-full bg-[#C85A32] hover:bg-[#B04B26] text-[#FBF9F5] text-sm font-medium px-5 py-2.5 transition-colors duration-300">
            Prenota Consulenza
          </button>
          <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-mobile-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="lg:hidden overflow-hidden border-t border-[#1C1E1D]/10 bg-[#FBF9F5]/95" data-testid="nav-mobile-menu">
            <div className="px-6 py-5 flex flex-col gap-4">
              {NAV_LINKS.map((l, i) => (
                <motion.a key={l.href} href={l.href} onClick={(e) => go(e, l.href)} data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                          initial={{ opacity: 0, x: -14 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }}
                          className="font-serif text-xl">{l.label}</motion.a>
              ))}
              <button onClick={(e) => go(e, "#contatti")} data-testid="nav-mobile-cta-booking"
                      className="mt-2 rounded-full bg-[#C85A32] text-[#FBF9F5] text-sm font-medium px-5 py-3 w-max">
                Prenota Consulenza
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
